import { useCallback, useEffect, useMemo, useState } from 'react';
import {
  applyLanguagePreference,
  getStoredLanguagePreference,
  normalizeLanguage,
  setStoredLanguagePreference,
} from '../utils/language';
import { useAuth } from '../context/AuthContext';

const useLanguagePreference = () => {
  const initialLanguage = useMemo(() => normalizeLanguage(getStoredLanguagePreference()), []);
  const [language, setLanguage] = useState(initialLanguage);
  const { user } = useAuth();

  useEffect(() => {
    const normalized = normalizeLanguage(language);
    setStoredLanguagePreference(normalized);
    applyLanguagePreference(normalized);
  }, [language]);

  useEffect(() => {
    if (!user || typeof user?.settings?.language !== 'string') {
      return;
    }

    const remoteLanguage = normalizeLanguage(user.settings.language);
    setLanguage((current) => {
      if (current === remoteLanguage) {
        return current;
      }
      return remoteLanguage;
    });
  }, [user]);

  const updateLanguage = useCallback((nextLanguage) => {
    setLanguage(normalizeLanguage(nextLanguage));
  }, []);

  return {
    language,
    setLanguage: updateLanguage,
  };
};

export default useLanguagePreference;
